import { studentConceptDataActionTypes as types } from 'Screens';
import InitialState from 'store/InitialState';
import { IConceptData } from 'store/StateInterfaces';


export default function studentConceptDataReducer(state = InitialState.studentConceptDataMap, action) {
    switch (action.type) {
        case types.LOAD_STUDENT_CONCEPT_DATA_SUCCESS:
            {
                const { conceptId, data } = action;
                let studentConceptDataMap = new Map<number, IConceptData>(state);
                studentConceptDataMap.set(conceptId, data);
                return studentConceptDataMap;
            }
        default:
            return state;
    }
} 